const evidenceStatusQueryKeys = {
  list: () => ["evidence-status", "list"],
  infinteList: () => ["evidence-status", "infinite-list"],
  details: (id: number) => ["evidence-status", "list", { id }],
};

export const EvidenceStatusQuery = {
  queryKeys: evidenceStatusQueryKeys,
};
